import { PetCustomPrice } from '@spike/pet-model';

export type CustomPriceType = 'standard' | 'pickup' | 'dropoff';

export interface CustomPriceDisplayRow {
    key: string;
    customPriceId: number;
    serviceId: number;
    serviceName: string;
    category: string;
    price: number;
    priceType: CustomPriceType;
    updatedAt: string;
    hasSiblingOnSameRecord: boolean;
}

export function toCustomPriceDisplayRows(customPrices: Array<PetCustomPrice>): Array<CustomPriceDisplayRow> {
    const rows: Array<CustomPriceDisplayRow> = [];

    for (const customPrice of customPrices) {
        const hasPickup = customPrice.pickupPrice != null;
        const hasDropoff = customPrice.dropoffPrice != null;
        const hasStandard = customPrice.price != null;

        if (hasPickup && hasDropoff) {
            rows.push({
                key: `${customPrice.id}-pickup`,
                customPriceId: customPrice.id,
                serviceId: customPrice.serviceId,
                serviceName: customPrice.serviceName,
                category: customPrice.category,
                price: customPrice.pickupPrice as number,
                priceType: 'pickup',
                updatedAt: customPrice.updatedAt,
                hasSiblingOnSameRecord: true
            });
            rows.push({
                key: `${customPrice.id}-dropoff`,
                customPriceId: customPrice.id,
                serviceId: customPrice.serviceId,
                serviceName: customPrice.serviceName,
                category: customPrice.category,
                price: customPrice.dropoffPrice as number,
                priceType: 'dropoff',
                updatedAt: customPrice.updatedAt,
                hasSiblingOnSameRecord: true
            });
            continue;
        }

        if (hasPickup) {
            rows.push({
                key: `${customPrice.id}-pickup`,
                customPriceId: customPrice.id,
                serviceId: customPrice.serviceId,
                serviceName: customPrice.serviceName,
                category: customPrice.category,
                price: customPrice.pickupPrice as number,
                priceType: 'pickup',
                updatedAt: customPrice.updatedAt,
                hasSiblingOnSameRecord: false
            });
            continue;
        }

        if (hasDropoff) {
            rows.push({
                key: `${customPrice.id}-dropoff`,
                customPriceId: customPrice.id,
                serviceId: customPrice.serviceId,
                serviceName: customPrice.serviceName,
                category: customPrice.category,
                price: customPrice.dropoffPrice as number,
                priceType: 'dropoff',
                updatedAt: customPrice.updatedAt,
                hasSiblingOnSameRecord: false
            });
            continue;
        }

        if (hasStandard) {
            rows.push({
                key: `${customPrice.id}-standard`,
                customPriceId: customPrice.id,
                serviceId: customPrice.serviceId,
                serviceName: customPrice.serviceName,
                category: customPrice.category,
                price: customPrice.price as number,
                priceType: 'standard',
                updatedAt: customPrice.updatedAt,
                hasSiblingOnSameRecord: false
            });
        }
    }

    return rows;
}

export function formatCustomPrice(price: number): string {
    return `$${Number(price).toFixed(2)}`;
}

export function getTransportationPillLabel(priceType: CustomPriceType): string | null {
    if (priceType === 'pickup') return 'Pick Up';
    if (priceType === 'dropoff') return 'Drop Off';
    return null;
}
